import ClientDetailsModal from './ClientDetailsModal.vue';

export default ClientDetailsModal;
